import React from 'react';
import _ from 'lodash';
import queryString from 'query-string';
import RedirectChoice from './RedirectChoice';
import useRouter from '@/hooks/useRouter';
import useTags from '@/hooks/useTags';
import TagTypes from '@/constants/TagTypes';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

export default function ExploreVirtualOpportunitiesChoice() {
  const { history } = useRouter();

  const interactionTypes = useTags(TagTypes.InteractionType);

  const virtual = _.find(interactionTypes.data, it => it.data.name === 'Virtual');

  return (
    <RedirectChoice
      icon={MagnifyingGlassIcon}
      title="Explore opportunities to share my skills and experience."
      onClick={() => history.push({
        pathname: '/projects-events',
        search: queryString.stringify({
          interactionTypes: virtual.id
        })
      })}
    />
  );
};
